import {Component, MeshComponent} from '@wonderlandengine/api';
import ColumnWarningAnimation from './animations/columnWarningOpacity.json';
import {Interpolation, Tween} from '@wonderlandengine/tweenjs';
import {FlatOpaque} from '../types/materials.js';

type alphaTween = {alpha: number};

export class ColumnWarning extends Component {
    static TypeName = 'column-warning';

    private _animation: Tween<alphaTween>;
    private _material: FlatOpaque;
    private _originalColor: number[];
    private _meshComp: MeshComponent;

    init(): void {
        // not 100% sure if this is the best way, but it must start deactivated.
        this.object.active = false;
    }

    start() {
        this._meshComp = this.object.getComponent(MeshComponent);
        this._material = this._meshComp.material.clone() as FlatOpaque;
        this._meshComp.material = this._material;
        this._originalColor = Array.from(this._material.getColor());
        const key = Object.getOwnPropertyNames(ColumnWarningAnimation.keyframes)[0];
        this._animation = new Tween({alpha: ColumnWarningAnimation.keyframes[key][0]})
            .to(
                {
                    alpha: [
                        ColumnWarningAnimation.keyframes[key][1],
                        ColumnWarningAnimation.keyframes[key][0],
                    ],
                },
                ColumnWarningAnimation.duration * 1000
            )
            .interpolation(Interpolation.Bezier)
            .repeat(Infinity)
            .onUpdate(this._updateValue);
    }

    onActivate(): void {
        this.activatePulse();
    }

    onDeactivate(): void {
        this.deactivatePulse();
    }

    activatePulse() {
        this.object.active = true;
        this._animation.start();
    }
    deactivatePulse() {
        this.object.active = false;
        this._animation.stop();
    }

    update(dt: number) {
        this._animation.update();
    }

    _updateValue = (value: alphaTween) => {
        this._originalColor[3] = value.alpha;
        this._material.setColor(this._originalColor);
    };
}
